module.exports = __webpack_public_path__ + "static/img/market.4bdf64eb.png";